import { LeancloudOfficialMessageType, FhtLeancloudCustomMessageType } from "../common/types";
import ImageChatMessageDto from "../models/messages/ImageChatMessageDto";
import LocationChatMessageDto from "@/models/messages/LocationChatMessageDto";
import { TextChatMessageDto } from "../models/messages/TextChatMessageDto";
import { MessageIOType } from "../models/MessageTypes";
import { assert } from "../common/assert";
import { TypedMessage, TextMessage, RecalledMessage } from "leancloud-realtime";
import { ImageMessage, LocationMessage } from "leancloud-realtime-plugin-typed-messages";
import { assertValidImageMessage } from "./validators";
import { getDeviceType } from "./messageConvertUtils";
import { FhtCustomMessage } from "./customMessagesPlugin/FhtCustomMessage";
import UnsupportedChatMessageDto, { UnsupportedMessageMap } from "@/models/messages/UnsupportedChatMessageDto";
import RecalledChatMessageDto from "@/models/messages/RecalledChatMessageDto";
export function convertToChatMessage(avMsg, myself) {
  //see https://leancloud.cn/docs/realtime-guide-beginner.html#hash222705779
  if (!(avMsg instanceof TypedMessage)) {
    console.error("Do not handle un-typed message of type: ", avMsg);
    return;
  }

  assert(myself.clientId, "myself.clientId falsy");
  var deviceType = getDeviceType(avMsg);
  var ioType = avMsg.from === myself.clientId ? MessageIOType.Sent : MessageIOType.Received;
  var timestamp = avMsg.timestamp;
  var msgType = avMsg.type;
  var officialTypeText = LeancloudOfficialMessageType[msgType];
  var isOfficialMessage = Boolean(officialTypeText);
  var customTypeText = FhtLeancloudCustomMessageType[msgType];
  var typeText = officialTypeText || customTypeText;
  assert(typeText, "can only be official typed message or custom by us");

  if (isOfficialMessage) {
    //this is leancloud officially supported typed message
    if (avMsg instanceof TextMessage) {
      return new TextChatMessageDto(avMsg.id, ioType, deviceType, timestamp, avMsg.text);
    } else if (avMsg instanceof ImageMessage) {
      assertValidImageMessage(avMsg);
      return new ImageChatMessageDto(avMsg.id, ioType, deviceType, timestamp, avMsg._lcfile.url, {
        width: avMsg._lcfile.metaData.width,
        height: avMsg._lcfile.metaData.height
      });
    } else if (avMsg instanceof LocationMessage) {
      assert(avMsg.type === LeancloudOfficialMessageType.LocationMessage, "invalid location message");
      return new LocationChatMessageDto(avMsg.id, ioType, deviceType, timestamp, avMsg._geoPoint._latitude, avMsg._geoPoint._longitude, avMsg._lctext);
    } else if (avMsg instanceof RecalledMessage) {
      return new RecalledChatMessageDto(avMsg.id, ioType, deviceType, timestamp);
    } else {
      var unsupportedDescription = UnsupportedMessageMap[msgType];

      if (unsupportedDescription) {
        return new UnsupportedChatMessageDto(avMsg.id, ioType, deviceType, timestamp, unsupportedDescription);
      }

      throw new Error("add support for converting official typed message: " + typeText);
    }
  } else if (customTypeText) {
    assert(avMsg instanceof FhtCustomMessage, "please register custom message for type: " + avMsg.type);
    return avMsg.convertToChatMessage(myself);
  } else {
    throw new Error("Do not anticipate this message of type: " + msgType);
  }
}